import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import TopTrustBar from './TopTrustBar';

const navItems = [
  { label: 'Accueil', path: '/' },
  { label: 'Fenêtres PVC', path: '/reparation-fenetre-pvc-paris-15/' },
  { label: 'Aluminium', path: '/reparation-fenetre-aluminium-paris-15/' },
  { label: 'Bois', path: '/reparation-fenetre-bois-paris-15/' },
  { label: 'Volet roulant', path: '/reparation-volet-roulant-paris-15/' },
  { label: 'Motorisation', path: '/motorisation-volet-roulant-paris-15/' },
  { label: 'Baie vitrée', path: '/reparation-baie-vitree-paris-15/' },
  { label: 'Devis', path: '/devis-fenetre-paris-15/' },
];

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <TopTrustBar />
      <header
        className={`fixed top-[40px] left-0 right-0 z-50 transition-all duration-300 bg-[#e6f7f5]/95 backdrop-blur-sm ${isScrolled ? 'shadow-sm' : ''}`}
      >
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16 md:h-18">
            {/* Logo */}
            <Link to="/" className="flex items-center group" aria-label="DF PRO — Réparation de fenêtres à Paris 15 — Retour à l'accueil">
              <img
                src="/logo_dfpro.svg"
                alt="DF PRO — Réparation de fenêtres à Paris 15"
                className="h-9 md:h-[44px] w-auto max-w-[280px]"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-sm whitespace-nowrap transition-colors ${
                    isActive(item.path)
                      ? 'text-brand-accent font-semibold'
                      : 'text-brand-text/70 hover:text-brand-accent'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </nav>

            {/* Desktop CTA */}
            <div className="flex items-center gap-2 md:gap-3">
              <Link
                to="/devis-fenetre-paris-15/"
                className="hidden md:inline-flex items-center gap-1.5 bg-brand-accent hover:opacity-90 text-white text-sm font-semibold px-4 py-2.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-file-text-line text-sm"></i>
                Devis gratuit
              </Link>
              <a
                href="tel:+33187668155"
                className="hidden md:inline-flex items-center gap-1.5 text-brand-text/80 hover:text-brand-accent text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill text-sm"></i>
                01 87 66 81 55
              </a>
              <a
                href="tel:+33187668155"
                className="md:hidden inline-flex items-center justify-center w-10 h-10 bg-brand-accent text-white rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-phone-fill text-lg"></i>
              </a>
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="lg:hidden inline-flex items-center justify-center w-10 h-10 text-brand-text/70 hover:text-brand-accent transition-colors cursor-pointer"
                aria-label="Menu"
              >
                <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#e6f7f5] border-t border-brand-mint shadow-lg animate-fade-in">
            <div className="max-h-[70vh] overflow-y-auto px-4 py-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`block px-4 py-3 rounded-lg text-sm transition-colors ${
                    isActive(item.path)
                      ? 'bg-brand-mint/60 text-brand-accent font-semibold'
                      : 'text-brand-text/80 hover:bg-brand-mint/50 hover:text-brand-accent'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <div className="mt-4 pt-4 border-t border-brand-mint">
                <Link to="/devis-fenetre-paris-15/" className="btn-primary w-full justify-center text-sm">
                  <i className="ri-file-text-line"></i> Devis gratuit
                </Link>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
}